module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group-list"
  }, [_c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "custom-form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "分组名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "筛选条件",
      "prop": "data"
    }
  }, _vm._l((_vm.form.data), function(item, index) {
    return _c('condition', {
      key: item.index,
      attrs: {
        "item": item,
        "conditions": _vm.condition
      },
      scopedSlots: _vm._u([{
        key: "button",
        fn: function(props) {
          return [(index === 0) ? _c('el-button', {
            attrs: {
              "icon": "el-icon-plus"
            },
            on: {
              "click": _vm.addItem
            }
          }) : _vm._e(), _vm._v(" "), (index !== 0) ? _c('el-button', {
            attrs: {
              "icon": "el-icon-minus"
            },
            on: {
              "click": function($event) {
                _vm.delItem(index)
              }
            }
          }) : _vm._e()]
        }
      }])
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("保 存")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56e0527c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/customer/edit-group.vue
// module id = 1279
// module chunks = 82